// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"MediumBtn_buttonWrapper__rvOQT","mediumBtn":"MediumBtn_mediumBtn__-W6If","active":"MediumBtn_active__hdPFF","disabledBtn":"MediumBtn_disabledBtn__0BOoE"};